/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../../SharedModules/Spinner/SpinnerNew';
import { getReferenceList } from '../../store/action';
import { multiPriceSelectionRadioData } from '../../utils/constant';
import RequestDrugPriceLoadDetailsHeader from './RequestDrugPriceLoadDetailsHeader';
import RequestDrugPriceLoadDetailsTable from './RequestDrugPriceLoadDetailsTable';
import { tabHighLigther } from '../../../../../SharedModules/utilities/utilities';

const RequestDrugPriceLoadDetails = () => {
  const [fullScreen, setFullScreen] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const loading = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.loading
  );
  const priceLoadDetailsFilter = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsFilter
  );
  const referenceData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.referenceData
  );
  const priceLoadDetailsTableData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsTableData
  );

  const comparePriceLoadDetailsTableData = useSelector(
    (state) =>
      state.sharedState.requestDrugPriceLoad.comparePriceLoadDetailsTableData
  );

  const trigerGetComentsExist = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.trigerGetComentsExist
  );

  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    dispatch(
      getReferenceList({
        codeDomainList: ['DRUG_CAT_CD'],
      })
    );
  }, []);

  React.useEffect(() => {//  setTimeout(() => setSuccessMessages([]), 5000);
                        }, [successMessages]);
  React.useEffect(() => {
    if (errorMessages?.length > 0) {
      tabHighLigther('/RequestDrugPriceLoadDetails', true);
    } else {
      tabHighLigther('/RequestDrugPriceLoadDetails', true);
    }
  }, [errorMessages]);
  useEffect(() => {
    const newTableData =
      priceLoadDetailsFilter?.multiPriceSelection ===
      multiPriceSelectionRadioData?.[0]?.value
        ? (priceLoadDetailsTableData &&
            priceLoadDetailsTableData.priceTableData) ||
          []
        : (priceLoadDetailsTableData &&
            priceLoadDetailsTableData.uraTableData) ||
          [];
    setTableData([...newTableData]);
  }, [priceLoadDetailsTableData, priceLoadDetailsFilter]);

  return (
    <div className="tabs-container tBillPanel custom-check">
      {loading && <Spinner load={loading} />}
      <CustomSeparator parent1="Invoice" parent2="Invoice Drug Price Detail" />
      {successMessages && (
        <DisplaySuccessMessages successMessages={successMessages} />
      )}
      {errorMessages && <DisplayErrorMessages errorMessages={errorMessages} />}
      {!fullScreen && (
        <RequestDrugPriceLoadDetailsHeader
          filters={priceLoadDetailsFilter}
          tableData={priceLoadDetailsTableData}
          compareTableData={comparePriceLoadDetailsTableData}
          setErrorMessages={setErrorMessages}
          setSuccessMessages={setSuccessMessages}
          successMessages={successMessages}
        />
      )}
      <RequestDrugPriceLoadDetailsTable
        fullScreen={fullScreen}
        setFullScreen={setFullScreen}
        setErrorMessages={setErrorMessages}
        filters={priceLoadDetailsFilter}
        referenceData={referenceData}
        trigerGetComentsExist={trigerGetComentsExist}
        tableData={tableData}
      />
    </div>
  );
};

export default RequestDrugPriceLoadDetails;
